import { parsePhoneNumber } from 'libphonenumber-js/max';

Mobi2Go.helpers.validator.phoneNumber = value => {
    if (Mobi2Go.headoffice.customer_phone_number_validation_enabled) {
        try {
            const parsed_phone_number = parsePhoneNumber(
                value,
                Mobi2Go.headoffice.country_iso3166_alpha2
            );
            if (!parsed_phone_number.isValid()) {
                return {
                    is_valid: false,
                    message: 'invalid phone number',
                };
            }
        } catch (e) {
            return {
                is_valid: false,
                message: 'invalid phone number',
            };
        }
    } else if (!value || value.length < 5 || value.length > 14) {
        return {
            is_valid: false,
            message: 'invalid phone number',
        };
    }

    return {
        is_valid: true,
        message: '',
    };
};
